<script setup lang="ts">
useDefaultMeta({
  title: 'Manajemen Staff KiriminAja | Kendali Tim Lebih Efisien',
  description:
    'Atur peran, akses, dan pantau performa tim operasional dari satu dashboard. Fitur Manajemen Staff KiriminAja bikin kerja tim lebih aman, cepat, dan efisien.',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa itu fitur Manajemen Staff?',
    answer:
      'Fitur KiriminAja yang membantu pemilik bisnis mengatur akses dan memantau kinerja tim operasional secara real time dalam satu dashboard.'
  },
  {
    question: 'Apakah ada batas jumlah staff?',
    answer: 'Tidak, Anda bebas menambah staff sesuai kebutuhan bisnis.'
  },
  {
    question: 'Apakah aman untuk data finansial?',
    answer:
      'Sangat aman. Sistem kami menggunakan <i>Role-Based Access Control (RBAC)</i> agar tiap peran memiliki batas akses yang spesifik.'
  },
  {
    question: 'Apakah fitur ini gratis?',
    answer:
      'Ya, fitur ini tersedia gratis untuk seluruh member terverifikasi KiriminAja.'
  },
  {
    question:
      'Bisakah diintegrasikan dengan fitur COD atau RMS (Return Management System)?',
    answer:
      'Bisa. Semua aktivitas staff otomatis tercatat di dashboard yang sama dengan fitur COD, RMS, dan laporan keuangan.'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Kendali Penuh, Tim Bekerja Tanpa Hambatan"
      sub-title="Manajemen Staff"
      description="Dengan Manajemen Staff KiriminAja, Anda bisa mengatur peran, akses, dan performa setiap anggota tim — tanpa kehilangan kendali. Semua aktivitas operasional tercatat otomatis, aman, dan transparan."
      hero-image="/images/manajemen-staff-banner-1.webp"
      button-label="Aktifkan Sekarang"
      :button-link="
        $utm.utmUrl('/login', {
          redirectTo: '/staff'
        })
      "
    />

    <KeunggulanManajemenStaffSection1 />
    <KeunggulanManajemenStaffSection2 />
    <KeunggulanManajemenStaffSection3 />
    <KeunggulanManajemenStaffSection4 />
    <FaqBase :faqs="faqs" />
    <KeunggulanManajemenStaffCta />
  </div>
</template>
